import ButtonComponent from "../components/button";
import LoaderColumnSvgComponent from "../components/loader-column-component";
import SpanComponent from "../components/span";
import {render, RenderPosition} from "./render";

export const renderShowMoreButton = (container, itemCountPerPage, itemsCount, pageNumber, onClickHandler) => {
  container.innerHTML = ``;
  const restToShow = itemsCount - (itemCountPerPage * pageNumber);

  if (restToShow <= 0) {
    return;
  }

  const countToShow = restToShow > itemCountPerPage ? itemCountPerPage : restToShow;

  const showMoreButton = new ButtonComponent({
    className: `product-list-page__show-all-button button-secondary`,
  });

  showMoreButton.getElement().dataset.state = `count`;
  showMoreButton.setClickHandler(() => {
    if (showMoreButton.getElement().dataset.state === `loader`) {
      return;
    }
    showMoreButton.getElement().dataset.state = `loader`;
    onClickHandler();
  });

  const titleComponent = new SpanComponent({
    text: `Показать еще ${countToShow}`
  });
  render(showMoreButton.getElement(), titleComponent.getElement(), RenderPosition.BEFOREEND);

  const svgComponent = new LoaderColumnSvgComponent();
  render(showMoreButton.getElement(), svgComponent.getElement(), RenderPosition.BEFOREEND);

  render(container, showMoreButton.getElement(), RenderPosition.BEFOREEND);
};
